package com.xtream.ui.platform

import androidx.compose.runtime.Composable

@Composable
actual fun isDpadNavigation(): Boolean {
   return true
}